import { MainLayout } from '#app/components/main-layout.tsx'

export default function AuthLayout() {
	return <MainLayout />
}
